export default function KpiCard({ label, value, sub, accent, testId, big }) {
  return (
    <div
      data-testid={testId}
      className={`rounded-lg border bg-white p-5 transition-shadow hover:shadow-md ${
        accent ? "border-blue-200 bg-blue-50/40" : "border-slate-200"
      } ${big ? "sm:col-span-2" : ""}`}
    >
      <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">{label}</div>
      <div
        className={`font-display font-extrabold leading-none tracking-tight text-slate-900 ${
          big ? "mt-3 text-4xl lg:text-5xl" : "mt-2 text-2xl lg:text-3xl"
        }`}
      >
        {value}
      </div>
      {sub && <div className="mt-2 text-xs text-slate-500">{sub}</div>}
    </div>
  );
}
